<igx-splitter [type]="typeVertical" style="width: 100%; height: 100%;">
  <igx-splitter-pane size="50%" minSize="50%">
    <igx-grid #gridCalendario [primaryKey]="'IdCalendario'" [width]="'100%'" [height]="'100%'" [locale]="localGrid"
              [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false"
              [moving]="true" [rowEditable]="true"  (rowEditEnter)="rowEditEnter()" (rowEditExit)="rowEditExit()"
              (selected)="onSelectionCalendario($event)" (rowEdit)="validarCalendario($event)" (rowEditDone)="addUpdateCalendario($event)"
              (keydown)="customKeydown($event, gridCalendario, 'calendario')" (rowSelectionChanging)="handleRowSelection(gridCalendario)"
              (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()" [igxGridState]="optionsGridLocal">
      <igx-grid-toolbar>
        <igx-grid-toolbar-title>
          <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event, 'calendario')"
                              (limpiarPalabras)="clearInput($event, 'calendario')" />
        </igx-grid-toolbar-title>
        <igx-grid-toolbar-actions>
          <button title="{{ 'MENSAJES.GRALS.EXPORTAR_EXCEL' | translate}}" igxButton="contained" igxRipple
                  (buttonClick)="exportarTodo()">
            <igx-icon>file_download</igx-icon>
          </button>
          <igx-grid-toolbar-hiding />
          <igx-grid-toolbar-pinning />
          <app-mas-opciones-grid #masOpcionesGCalendario [arrayDatosAVer]="[0, 1, 3, 6]"
                                 (opcionSeleccionada)="onSelectionDropDown($event, 'calendario')"/>
        </igx-grid-toolbar-actions>
      </igx-grid-toolbar>
      <ng-template igxSortHeaderIcon>
        <igx-icon>north</igx-icon>
      </ng-template>
      <ng-template igxSortAscendingHeaderIcon>
        <igx-icon>north</igx-icon>
      </ng-template>
      <ng-template igxSortDescendingHeaderIcon>
        <igx-icon>south</igx-icon>
      </ng-template>
      <ng-template igxExcelStyleHeaderIcon>
        <igx-icon>filter_alt</igx-icon>
      </ng-template>
      <igx-column field="CodigoCalendario" header="{{ 'GRIDS.CALENDARIOS.COL_CALENDARIO' | translate}}*" [dataType]="'string'" width="200px" [sortable]="true" [resizable]="true" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_CALENDARIO' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
        <ng-template igxCellEditor let-cell="cell">
          <igx-input-group>
            <input igxInput name="CodigoCalendario" [(ngModel)]="cell.editValue" uppercase [igxTextSelection]="true" [igxFocus]="true"
                   (keydown)="stopPropagationPegado($event)" type="text" maxlength="20"/>
          </igx-input-group>
        </ng-template>
      </igx-column>
      <igx-column field="DescripcionCalendario" header="{{ 'GRIDS.CALENDARIOS.COL_DESCRIPCION' | translate}}*" [dataType]="'string'" width="300px" [sortable]="true" [resizable]="true" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_DESCRIPCION' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
        <ng-template igxCellEditor let-cell="cell">
          <igx-input-group>
            <input igxInput name="DescripcionCalendario" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
                   (keydown)="stopPropagationPegado($event)" type="text"  maxlength="40"/>
          </igx-input-group>
        </ng-template>
      </igx-column>
      <igx-column field="Lunes" header="{{ 'GRIDS.CALENDARIOS.COL_LUNES' | translate}}*" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_LUNES' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
      </igx-column>
      <igx-column field="Martes" header="{{ 'GRIDS.CALENDARIOS.COL_MARTES' | translate}}*" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_MARTES' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
      </igx-column>
      <igx-column field="Miercoles" header="{{ 'GRIDS.CALENDARIOS.COL_MIERCOLES' | translate}}*" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_MIERCOLES' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
      </igx-column>
      <igx-column field="Jueves" header="{{ 'GRIDS.CALENDARIOS.COL_JUEVES' | translate}}*" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_JUEVES' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
      </igx-column>
      <igx-column field="Viernes" header="{{ 'GRIDS.CALENDARIOS.COL_VIERNES' | translate}}*" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_VIERNES' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
      </igx-column>
      <igx-column field="Sabado" header="{{ 'GRIDS.CALENDARIOS.COL_SABADO' | translate}}*" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_SABADO' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
      </igx-column>
      <igx-column field="Domingo" header="{{ 'GRIDS.CALENDARIOS.COL_DOMINGO' | translate}}*" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false" >
<!--        <ng-template igxHeader let-column>-->
<!--          <div title="{{ 'GRIDS.CALENDARIOS.COL_DOMINGO' | translate}}" class="header-required">{{column.header + '*'}}</div>-->
<!--        </ng-template>-->
      </igx-column>
      <igx-column field="Predeterminado" header="{{ 'GRIDS.CALENDARIOS.COL_PREDETERMINADO' | translate}}" [dataType]="'boolean'" width="150px" [sortable]="true" [resizable]="false"  />
      <!--Acciones Editar, Agregar y Borrar-->
      @if (showActionStrip) {
        <igx-action-strip #actionstrip>
          <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px"
                  (buttonClick)="accionStripRow(actionstrip.context, 1, 'calendario')">
            <igx-icon>add</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple
                  style="margin-right: 5px"
                  (click)='startEdit(actionstrip.context)'>
            <igx-icon>edit</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab"
                  (buttonClick)="accionStripRow(actionstrip.context, 2, 'calendario')">
            <igx-icon>delete</igx-icon>
          </button>
        </igx-action-strip>
      }
    </igx-grid>
  </igx-splitter-pane>
  <igx-splitter-pane size="49%" minSize="49%'">
    <igx-grid #gridFecha [locale]="localGrid" [width]="'100%'" [height]="'100%'"
              [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="rowSelectionMultiple" [selectRowOnClick]="false"
              [primaryKey]="'IdFecha'" (keydown)="customKeydown($event, gridFecha, 'fechas')"
              (rowEditEnter)="rowEditEnterFecha()" (rowEditExit)="rowEditExitFecha()" [batchEditing]="true" [rowEditable]="false"
              (rowEdit)="validarFechas($event)" (contextMenu)="menuContextual($event)" (rowSelectionChanging)="handleRowSelection(gridFecha)"
              (window:click)="disableContextMenu()" paste-handler-neodata [igxGridState]="optionsGridLocal">
      <igx-grid-toolbar>
        <igx-grid-toolbar-title>
          <app-filtro-general-moderno #filtroGeneralFecha
                                      descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}"
                                      (enterPalabra)="filterInput($event, 'fecha')"
                                      (limpiarPalabras)="clearInput($event, 'fecha')"/>
        </igx-grid-toolbar-title>
        <igx-grid-toolbar-actions>
          @if (!gridFecha.rowEditable) {
            <button title="{{ 'BOTONES.EDITAR' | translate}}" igxButton="contained" igxRipple
                    (buttonClick)="abrirEdicion()">
              <igx-icon>edit</igx-icon>
            </button>
          }
          @if (gridFecha.rowEditable) {
            <button title="{{ 'BOTONES.EDITANDO' | translate}}" igxButton="contained" igxRipple
                    (buttonClick)="cancelarEdicion()">
              <igx-icon>edit</igx-icon>
            </button>
          }
          <button title="{{ 'TOOLTIPS.DESHACER' | translate}}" igxButton="contained" igxRipple
                  [disabled]="!gridFecha.transactions.canUndo" (buttonClick)="undo()">
            <igx-icon>undo</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.REHACER' | translate}}" igxButton="contained" igxRipple
                  [disabled]="!gridFecha.transactions.canRedo" (buttonClick)="redo()">
            <igx-icon>redo</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.GUARDAR' | translate}}" igxButton="contained" igxRipple
                  [disabled]="!hasTransactions" (buttonClick)="commit()">
            <igx-icon>save</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.DESCARTAR' | translate}}" igxButton="contained" igxRipple
                  [disabled]="!hasTransactions" (buttonClick)="discard()">
            <igx-icon>clear</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.BORRAR_TODO' | translate}}" igxButton="contained" igxRipple
                  [disabled]="!gridFecha.rowEditable" (buttonClick)="marcarTodoBorrar()">
            <igx-icon>delete_sweep</igx-icon>
          </button>
          <igx-grid-toolbar-hiding />
          <igx-grid-toolbar-pinning />
          <app-mas-opciones-grid #masOpcionesGFecha [arrayDatosAVer]="[1, 5]"
                                 (opcionSeleccionada)="onSelectionDropDown($event, 'fecha')"/>
        </igx-grid-toolbar-actions>
      </igx-grid-toolbar>
      <ng-template igxSortHeaderIcon>
        <igx-icon>north</igx-icon>
      </ng-template>
      <ng-template igxSortAscendingHeaderIcon>
        <igx-icon>north</igx-icon>
      </ng-template>
      <ng-template igxSortDescendingHeaderIcon>
        <igx-icon>south</igx-icon>
      </ng-template>
      <ng-template igxExcelStyleHeaderIcon>
        <igx-icon>filter_alt</igx-icon>
      </ng-template>
      <igx-column field="FechaNoLaborable" header="{{ 'GRIDS.CALENDARIO_FECHAS.COL_FECHA_NO_LABORABLE' | translate}}" [dataType]="'date'" [width]="'200px'"
                  [sortable]="true" [resizable]="true" >
        <ng-template igxHeader let-column>
          <div class="header-required">{{column.header + '*'}}</div>
        </ng-template>
      </igx-column>
      <igx-column field="Descripcion" header="{{ 'GRIDS.CALENDARIO_FECHAS.COL_DESCRIPCION' | translate}}" [dataType]="'string'" width="300px" [sortable]="true" [resizable]="true" >
        <ng-template igxHeader let-column>
          <div class="header-required">{{column.header + '*'}}</div>
        </ng-template>
      </igx-column>
      <!--Acciones Editar, Agregar y Borrar-->
      @if (showActionStripFecha) {
        <igx-action-strip #actionstrip>
          <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px"
                  [hidden]="!gridFecha.rowEditable"
                  (buttonClick)="accionStripRow(actionstrip.context, 1, 'fecha')">
            <igx-icon>add</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple
                  style="margin-right: 5px" (click)='startEdit(actionstrip.context)'>
            <igx-icon>edit</igx-icon>
          </button>
          <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab"
                  [hidden]="isDeleted(actionstrip.context) || !gridFecha.rowEditable"
                  (buttonClick)="actionstrip.context.delete()">
            <igx-icon>delete</igx-icon>
          </button>
        </igx-action-strip>
      }
    </igx-grid>
  </igx-splitter-pane>
</igx-splitter>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu"
                             [size]="sizeMenu" [subMenusOpciones]="subMenusOpciones"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX"
                             [y]="contextmenuY"/>
}
